import { getMovementGallery } from './imageRegistry';

const createMovement = (name, slug, points, description, galleryKey) => ({
  name,
  slug,
  points,
  description,
  get images() {
    return getMovementGallery(galleryKey);
  }
});

export const movements = {
  reformer: createMovement(
    'REFORMER',
    'reformer',
    ['Low-impact', 'Flow', 'Tone'],
    'Experience the signature Pilates reformer. Our spring-based apparatus creates smooth, flowing movements that challenge your entire body while protecting your joints. Build lean muscle, improve posture, and discover your body\'s natural grace.',
    'reformer'
  ),
  gyrotonic: createMovement(
    'GYROTONIC®',
    'gyrotonic',
    ['Flow', 'Decompress', 'Align'],
    'Experience the revolutionary GYROTONIC® method. This unique system combines elements of yoga, dance, gymnastics, and swimming to create three-dimensional, flowing movements that mobilize the spine and joints with minimal effort and maximum efficiency. GYROTONIC® exercises decompress the spine while strengthening the body\'s core stability.',
    'gyrotonic'
  ),
  cadillac: createMovement(
    'CADILLAC',
    'cadillac',
    ['Full-body', 'Strength', 'Mobility'],
    'Master the Cadillac\'s endless possibilities. This versatile apparatus offers unparalleled support and resistance, perfect for building strength while enhancing flexibility. From gentle rehabilitation to advanced conditioning, the Cadillac adapts to your journey.',
    'cadillac'
  ),
  mat: createMovement(
    'MAT',
    'mat',
    ['Core', 'High Intensity', 'Awareness'],
    'Return to Pilates\' origins on the mat. Using only your body weight and focused intention, develop profound core strength and body awareness. These dynamic sequences will challenge your stability, coordination, and mental focus.',
    'mat'
  ),
  privates: createMovement(
    'PRIVATES',
    'privates',
    ['Curated', 'Progression', 'Therapy'],
    'Unlock your potential with personalized instruction. Our expert instructors create bespoke sessions tailored to your unique needs, goals, and body. Whether seeking rehabilitation, performance enhancement, or deeper understanding, private sessions accelerate your progress.',
    'privates'
  ),
};

// Helper function to get all movements as an array
export const getMovements = () => Object.values(movements);

// Helper function to get movement by slug
export const getMovementBySlug = (slug) => {
  return Object.values(movements).find(movement => movement.slug === slug);
};

// Helper function to get movement images for a specific movement
export const getMovementImages = (movementKey) => {
  return movements[movementKey]?.images || [];
};